module.exports = __webpack_public_path__ + "static/media/one.1a37f9c2.svg";